// extracted by mini-css-extract-plugin
module.exports = {"questContainer":"Question-module--questContainer--2BN7G"};